import { render } from "./UiTable.vue?vue&type=template&id=183f4518&scoped=true&ts=true"
import script from "./UiTable.vue?vue&type=script&lang=ts"
export * from "./UiTable.vue?vue&type=script&lang=ts"

import "./UiTable.vue?vue&type=style&index=0&id=183f4518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183f4518"]])

export default __exports__